import { createGlobalStyle } from 'styled-components';

export const MicrositeV2GlobalStyle = createGlobalStyle`
  * {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
`;
